"use strict";
import classNames from "classnames";
import reactUtils from "../../react_utils";
import Account from "../../api/account";
import { shouldShowIndexShipmentSelector } from "../document_assignment/document_assignment_loader";
var bem = reactUtils.makeBem("load-assigner-progress");
export default React.createClass({
  propTypes: {
    content: React.PropTypes.object.isRequired,
    items: React.PropTypes.array.isRequired
  },
  render() {
    return /* @__PURE__ */ React.createElement("div", { className: bem() }, Account.indexAuditSplitEnabled() ? /* @__PURE__ */ React.createElement("div", null, this.indicators()) : null, /* @__PURE__ */ React.createElement("div", null, this.props.content));
  },
  indicators() {
    return this.props.items.map((item) => this.indicator(item.text, item.isFullfilled));
  },
  indicator(text, isFulfilled) {
    const classes = classNames({
      [`${bem("__pill")}`]: true,
      [`${bem("__pill__complete")}`]: isFulfilled
    });
    return /* @__PURE__ */ React.createElement("span", { className: classes, key: text }, /* @__PURE__ */ React.createElement("span", { className: `icon-checkmark-circle-${isFulfilled ? "green" : "grey"} icon--no-repeat icon--sm` }), text);
  }
});
function multiShipmentBoxesEnabled(selectedLoad, documentBatch) {
  return documentBatch.documents.some((doc) => shouldShowIndexShipmentSelector(selectedLoad, doc, Account.currentSettings(), "index"));
}
function markPODForShipmentsItem(shipmentDocumentSelections) {
  const everyShipmentHasPod = shipmentDocumentSelections.every((shipmentDocumentSelection) => {
    return shipmentDocumentSelection.documents.some((doc) => doc.is_pod);
  });
  return { text: "Mark POD for shipments", isFullfilled: everyShipmentHasPod };
}
function markPODItem(documentBatch, currentDocGroup) {
  const hasPod = documentBatch.documents.filter((x) => x.document_group_id === currentDocGroup.id).filter((x) => x.is_pod).length > 0;
  return { text: "Mark POD", isFullfilled: hasPod };
}
function linkCustomerDocsToShipments(documentBatch, shipmentDocumentSelections) {
  const customerVisibleDocTypes = Account.customerVisibleDocumentTypes();
  const customerDocs = documentBatch.documents.filter((doc) => {
    return customerVisibleDocTypes.includes(doc.type);
  });
  const everyDocHasShipment = customerDocs.every((doc) => {
    return shipmentDocumentSelections.some((shipmentDocumentSelection) => {
      return shipmentDocumentSelection.documents.some((shipmentDoc) => shipmentDoc.id === doc.id);
    });
  });
  return { text: "Link customer documents to shipments", isFullfilled: everyDocHasShipment };
}
export function getLoadAssignerProgressItems(selectedLoad, documentBatch, currentDocGroup, invoiceDataEntered, shipmentDocumentSelections) {
  const items = [
    { text: "Assign Load", isFullfilled: !!selectedLoad },
    { text: "Verify Invoice data", isFullfilled: !!selectedLoad && invoiceDataEntered }
  ];
  const showMarkPOD = !selectedLoad || selectedLoad && !selectedLoad.requires_auditor_manual_marking_of_POD;
  if (multiShipmentBoxesEnabled(selectedLoad, documentBatch)) {
    if (showMarkPOD) {
      items.push(markPODForShipmentsItem(shipmentDocumentSelections));
    }
    items.push(linkCustomerDocsToShipments(documentBatch, shipmentDocumentSelections));
  } else {
    if (showMarkPOD) {
      items.push(markPODItem(documentBatch, currentDocGroup));
    }
  }
  return items;
}
